// Photo Privacy is now shown every time - no localStorage persistence
export const hasAcceptedPhotoPrivacy = (): boolean => {
  // Always return false to show photo privacy modal every time
  return false;
};

export const acceptPhotoPrivacy = (): void => {
  // No longer saves to localStorage
  // Photo Privacy must be accepted each time
};

export const clearPhotoPrivacy = (): void => {
  // No localStorage to clear
  // Keeping function for backward compatibility
};
